import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";
import {
  setLoading,
  setError,
  setConfigurations,
  addConfiguration,
  setEditingConfigurationId,
  setEditingConfiguration
} from "../../../features/common/configurationSlice";

import {
  getConfigurationById,
  getUserById,
  registerUser,
  updateUser,
  configurationAdd,
  updateConfiguration
} from "../../../services/userservice";

const AddConfiguration = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, editingConfigurationId } = useSelector((state) => state.configuration);
  const editingConfiguration = useSelector((state) => state.configuration.editingConfiguration);
  const [isEditMode, setIsEditMode] = useState(false);
  const [dob, setDOB] = useState(null);
  const [formData, setFormData] = useState([
    {
      name: "",
      category: "",
      status: ""
    },
  ]);

  useEffect(() => {
    if (id && id !== "add" && editingConfigurationId !== id) {
      dispatch(setEditingConfigurationId(id));
      dispatch(setEditingConfiguration(id));
      setIsEditMode(true);
      fetchUserData(id);
    }
  }, [id, editingConfigurationId, dispatch]);

  const fetchUserData = async (id) => {
    try {
      dispatch(setLoading());
      const response = await getConfigurationById(id);
      // console.log("response++++++++", response);
      if (response) {
        // Update form data with fetched coupon data
        const responseData = response?.data;
        setFormData({
          name: responseData?.name,
          api_url: responseData?.api_url,
          key: responseData?.key,
          value: responseData?.value,
          category: responseData?.category,
          status: responseData?.status
        });
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoading(false)); // Set loading to false after data is fetched or on error
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch(setLoading());
      const response =
        id && id !== "add"
          ? await updateConfiguration(id, formData)
          : await configurationAdd(formData);

      if (response) {
        navigate("/configurations"); // Navigate after API call is completed
      }
    } catch (error) {
      dispatch(setError(error.message));
      alert(error.message);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleDateChange = (name, date) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: date,
    }));
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     [name]: name === "name" ? value.toUpperCase().replace(/\s+/g, "") : value,
  //   }));
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     [name]: value,
  //   }));
  // };
  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Add Configuration </h1>
            </div>
            {/* /.col */}
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Add Configuration</Link>
                </li>
                <li className="breadcrumb-item active">Configurations</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div classname="row">
            <div classname="col-md-12">
              <form onSubmit={handleSubmit}>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">VENDOR NAME</label>

                          {/* <input
                            type="text"
                            className="form-control"
                            id="exampleInputEmail1"
                            placeholder="Enter Vendor Name"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                          /> */}

                          <select
                            className="form-control"
                            id="exampleInputEmail1"
                            placeholder="Enter Vendor Name"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                          >
                            <option value="">Select Vendor</option>
                            <option value="TRIPJACK">TRIPJACK</option>
                            <option value="TBO">TBO</option>
                          </select>

                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Category</label>
                          <select
                            className="form-control"
                            id="category"
                            name="category"
                            value={formData.category}
                            onChange={handleInputChange}
                          >
                            <option value="">Select Category</option>
                            <option value="flight">FLIGHT</option>
                            <option value="hotel">HOTEL</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>STATUS</label>
                          <select
                            className="form-control"
                            id="status"
                            name="status"
                            value={formData.status}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            <option value="active">ACTIVE</option>
                            <option value="inactive">INACTIVE</option>
                          </select>
                        </div>
                      </div>
                      {/* <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">API URL</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputEmail1"
                          placeholder="Enter API Url"
                          name="api_url"
                          value={formData.api_url}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div> */}
                    </div>
                    {/* <div className="row">
                 <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">API KEY</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputApiKey"
                          placeholder="Enter API Key"
                          name="key"
                          value={formData.key}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">API VALUE</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputApiValue"
                          placeholder="Enter API Key Value"
                          name="value"
                          value={formData.value}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                 </div> */}

                    {/* <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>STATUS</label>
                        <select
                          className="form-control"
                          id="status"
                          name="status"
                          value={formData.status}
                          onChange={handleInputChange}
                        >
                          <option value="">Select</option>
                          <option value="active">ACTIVE</option>
                          <option value="inactive">INACTIVE</option>
                        </select>
                      </div>
                    </div>
                  </div> */}



                  </div>
                  <div className="card-footer">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddConfiguration;
